<template>
    <div>
        <breadcrumb :links="crumbNav"></breadcrumb>
        <div class="top-row row">
            <div class="col-md col-12">
                <heading :text="`Top offers`"></heading>
            </div>
            <div class="col-md col-12" v-if="specialOffers.length">
                <sort @orderChange="sortOffers"></sort>
            </div>
        </div>
        <div class="offer-block" v-if="!pageLoading">
            <div v-if="!busy" class="row offer-block__list">
                <div :key="offer.id" class="col-12 col-lg-6 col-xl-4" v-for="offer in specialOffers">
                    <card :data="offer"></card>
                </div>
            </div>
            <div v-else class="loading-screen row justify-content-center">
                <div class="col-2">
                    <div class="loader">
                        <span class="loader__progress">&nbsp;</span>
                    </div>
                </div>
            </div>
            <div class="row offer-block__pagination" v-if="specialOffers.length">
                <div class="col-12 col-lg-3 pagination-text">
                    <span>Showing {{currentVehicles}} of {{itemCount}} vehicles </span>
                </div>
                <div class="col-12 col-lg-6">
                    <b-pagination
                            v-model="currentPage"
                            :total-rows="itemCount"
                            :per-page="itemsPerPage"
                            align="center"
                    ></b-pagination>
                </div>
            </div>
            <div v-else>
                <h2 class="text-center">Sorry, there are no current offers for {{ type | friendlyName }}s</h2>
            </div>
        </div>
        <loader v-else></loader>
        <div class="row disclaimer-block">
            <div class="col">
                <disclaimer :cms-text="disclaimer"></disclaimer>
            </div>
        </div>
    </div>
</template>

<script>
    import Breadcrumb from "../components/Breadcrumb";
    import Heading from "../components/Heading";
    import Sort from "../components/Sort";
    import Card from "../components/Card";
    import Disclaimer from "../components/Disclaimer";
    import {GET_OFFERS_FULL, GET_DISCLAIMER} from "../store/action-types";
    import Loader from "../components/Loader";

    export default {
        name: "Offers",

        props: [
            'type'
        ],

        components:{
            Loader,
            Breadcrumb,
            Heading,
            Sort,
            Card,
            Disclaimer
        },
        data(){
            return{
                crumbNav:[
                    {name:'home', text: 'Small business offers home'}
                ],
                currentPage: 1,
                itemsPerPage: 9,
                offerCount: 0,
                order: 'finance-asc',
                disclaimerId: 1,
                busy: true,
                pageLoading: true
            }
        },

        filters: {
            friendlyName(value) {
                return (value === 'CAR') ? 'car' : 'van';
            }
        },

        methods:{
            sortOffers: function(order){
                this.order = order;
                this.getOffers();
            },
            getOffers: function() {
                this.busy = true;
                let app = this;
                this.$store.dispatch(GET_OFFERS_FULL,{data: {limit:this.itemsPerPage, page:this.currentPage, order:this.order, type: this.type}, callback:function(){
                        app.$scrollTo('.offer-block');
                    }});
            },
            getDisclaimer: function() {
                this.$store.dispatch(GET_DISCLAIMER, this.disclaimerId)
            }
        },
        watch:{
            currentPage: function() {
                this.getOffers();
            },
            specialOffers: function() {
                this.offerCount = this.specialOffers.length;
                this.busy = false;
                this.pageLoading = false;
            }
        },
        computed: {
            specialOffers: function() {
                return this.$store.state.OFFERS_FULL;
            },
            itemCount: function() {
                return this.$store.state.OFFERS_FULL_COUNT;
            },
            currentVehicles: function() {
                let start = (this.currentPage * this.itemsPerPage - (this.itemsPerPage));
                let first = start + 1;
                let end = start + this.offerCount;
                return first + ' - ' + end
            },
            disclaimer: function() {
                return this.$store.state.CMS_DISCLAIMER;
            }
        },
        created: function(){
            this.pageLoading = true;
            this.getOffers();
            this.getDisclaimer();
            this.$tracking.logPageLoad('SME-Price-List:Offers');
        },
        mounted() {
            this.$scrollTo('.crumb-nav');
        }
    }
</script>

<style lang="stylus">
    .offer-block
        &__pagination
            margin-top 20px;
            .pagination-text
                text-align left;
                @media (max-width: 960px)
                    text-align center
            .pagination
                .page-item
                    .page-link
                        width 45px
                        height 45px
                        text-align center
                        border-radius 0 !important
                        line-height 32 px
                        font-size 18 px
                        border none
                        color #004666
                    &.active
                        .page-link
                            z-index: 1;
                            color: #fff;
                            background-color: #004666;
                            border none
                    &.disabled
                        .page-link
                            color #dddddd
                    &:selection
                        background: #004666;
                        color: #fff;
        .loading-screen
            .loader
                display flex
                position static
                //z-index 100
                width 100%
                height 100%
                justify-content center
                align-items center
                background-color #ffffff
                transition all .3s
                //margin 50px
                &__progress
                    width 10rem
                    height 10rem
                    border 5px solid #004666
                    border-left-color transparent
                    border-radius 50%
                    animation rotate 1.5s linear infinite
                @-webkit-keyframes rotate
                    from
                        -webkit-transform rotate(0deg)
                    to
                        -webkit-transform rotate(360deg)

    .disclaimer-block
        margin 20px -15px
</style>